import Image from "next/image";

import { Entity } from "models/entity";

import { faCube } from "@fortawesome/free-solid-svg-icons/faCube";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { sectors } from "consts/sectors";

const EntityLogo = ({
  entity,
  size = 33,
}: {
  entity: Entity;
  size?: number;
}) => {
  const { logoUrl, prettyName, sector } = entity;
  if (logoUrl?.small) {
    return (
      <Image src={logoUrl?.small} alt={prettyName} width={size} height={size} />
    );
  }

  const icon = sectors.find((s) => s.name === sector)?.icon || faCube;
  return <FontAwesomeIcon icon={icon} />;
};

export default EntityLogo;
